import {
    LOGIN_FAIL,
    LOGIN_SUCCESS,
    LOGIN_REQUEST,
    LOGOUT,
    SET_AUTHENTICATED_USER
} from '../actions/authActions';

const initialState = {
    isLogged: false,
    user: null,
    loading: false,
    message: '',
    error: null
};

function authReducer(state = initialState, action) {
    switch (action.type) {
        case LOGIN_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case LOGIN_FAIL:
            return {
                ...state,
                loading: false,
                isLogged: false,
                message: 'Operation failed',
                error: action.error
            };

        case LOGIN_SUCCESS:
            return {
                ...state,
                user: action.payload?.user || action.payload,
                loading: false,
                message: 'Operation succeeded',
                isLogged: true,
                error: null
            };

        case SET_AUTHENTICATED_USER:
            return {
                ...state,
                user: action.payload,
                isLogged: true
            };

        case LOGOUT:
            return {
                ...initialState,
                isLogged: false
            };

        default:
            return state;
    }
}

export default authReducer;
